import { Suspense, lazy } from 'react';

const MarkdownEditorInner = lazy(() =>
  import('./MarkdownEditorInner').catch(() => {
    window.location.reload();
    return { default: () => null } as never;
  })
);

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  readOnly?: boolean;
  className?: string;
}

export function MarkdownEditor(props: MarkdownEditorProps) {
  return (
    <Suspense
      fallback={
        <div className="flex h-32 items-center justify-center rounded-lg border border-gray-700 bg-surface-900 text-xs text-gray-500">
          Loading editor...
        </div>
      }
    >
      <MarkdownEditorInner {...props} />
    </Suspense>
  );
}
